import { createContext } from 'react';
import { AccountDto } from '@/api-client/autogenerated';

interface AccountContextType {
  accounts: AccountDto[];
  selectedAccountId: number | null;
  selectedAccount: AccountDto | null;
  setSelectedAccountId: (id: number) => void;
}

export const AccountContext = createContext<AccountContextType>({
  accounts: [],
  selectedAccountId: null,
  selectedAccount: null,
  setSelectedAccountId: () => {},
});
